export enum BusinessMode {
    UNKNOWN,
    ADVERTISE,
    SYSTEM
}